import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'shared/shared.module';
import { TableEditableService } from 'shared/table/table-editable/table-editable.service';

import { AccountInformationService } from './account-information.service';
import { BaseAccountSegmentComponent } from './components/base/_base-segment.component';

// segments
import { ProfileComponent } from './components/profile/profile.component';
import { ProfileFormComponent } from './components/profile/profile-form.component';
import { TeamComponent } from './components/team/team.component';
import { TeamFormComponent } from './components/team/team-form.component';
import { PreferencesComponent } from './components/preferences/preferences.component';
import { PreferencesFormComponent } from './components/preferences/preferences-form.component';
import { BillingComponent } from './components/billing/billing.component';
import { BillingFormComponent } from './components/billing/billing-form/billing-form.component';
import { PlanInfoComponent } from './components/billing/plan-info/plan-info.component';
import { BrandComponent } from './components/brand/brand.component';
import { BrandFormComponent } from './components/brand/brand-form.component';
import { TradeInfoComponent } from './components/trade-info/trade-info.component';
import { TradeInfoFormComponent } from './components/trade-info/trade-info-form.component';



@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    BaseAccountSegmentComponent,
    ProfileComponent,
    ProfileFormComponent,
    TeamComponent,
    TeamFormComponent,
    PreferencesComponent,
    PreferencesFormComponent,
    BillingComponent,
    BillingFormComponent,
    PlanInfoComponent,
    BrandComponent,
    BrandFormComponent,
    TradeInfoComponent,
    TradeInfoFormComponent,
  ],
  providers: [
    AccountInformationService,
    TableEditableService,
  ],
})
export class AccountInformationModule { }
